import React from "react";
import { Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataGrid, GridToolbar, frFR } from "@mui/x-data-grid";
import ContactService from "../../services/contact-service";
import DialogModificationNc from "../../pages/gestion-nc/dialog-modification-nc";
import { toast } from "react-toastify";
import AuthorizationService from "../../services/authorization-service";

const NcAttenteTable = ({ contacts, sendUpdate }) => {
  const [pageSize, setPageSize] = React.useState(5);

  // Modèle de visibilité des colonnes
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    id: false,
    subscription_date: false,
    genre: false,
    author: false,
    birthdate: false,
    metier: false,
    ville: false,
    code_postal: false,
    secteur_gf: false,
    adresse_postale: false,
  });

  // Configuration des colonnes avec flexibilité pour masquer ou afficher des colonnes
  const columns = [
    {
      field: "id",
      headerName: "Id",
      flex: 0,
      width: 40,
      headerClassName: "header-prog31",
    },
    {
      field: "lastname",
      headerName: "Nom",
      flex: 1,
      headerClassName: "header-prog31",
    },
    {
      field: "firstname",
      headerName: "Prénom",
      flex: 1,
      headerClassName: "header-prog31",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      headerClassName: "header-prog31",
    },
    {
      field: "telephone",
      headerName: "Téléphone",
      flex: 0,
      width: 100,
      headerClassName: "header-prog31",
    },
    {
      field: "genre",
      headerName: "Genre",
      hide: true, // Masquée par défaut
      headerClassName: "header-prog31",
    },
    {
      field: "etat_mineur",
      headerName: "Ado/Adulte",
      flex: 0,
      width: 110,
      headerClassName: "header-prog31",
    },
    {
      field: "birthdate",
      headerName: "Né le",
      hide: false, // Visible par défaut
      flex: 0,
      width: 120,
      headerClassName: "header-prog31",
    },
    {
      field: "subscription_date",
      headerName: "Date de saisie",
      hide: false, // Visible par défaut
      flex: 0,
      width: 120,
      headerClassName: "header-prog31",
    },
    {
      field: "libelle_source",
      headerName: "Source",
      flex: 1,
      headerClassName: "header-prog31",
      headerAlign: "center",
    },
    {
      field: "metier",
      headerName: "Métier",
      flex: 1,
      headerClassName: "header-prog31",
    },
    {
      field: "action",
      headerName: "Actions",
      flex: 0,
      width: 150,
      headerClassName: "header-prog31",
      renderCell: (id) => (
        <React.Fragment>
          <DialogModificationNc nc={id.row} id={id} sendUpdate={sendUpdate} />
          {AuthorizationService.writeMesSaisies() && (
            <Button
              id="deleteBtn"
              style={{
                backgroundColor: "#e8605d",
                color: "#fff",
                padding: "7px 7px",
              }}
              onClick={() => {
                if (
                  window.confirm(
                    "Êtes-vous sûr de vouloir supprimer cet enregistrement ?"
                  )
                ) {
                  handleDelete(id);
                }
              }}
              variant="contained"
              color="primary"
              type="submit"
            >
              <DeleteIcon />
            </Button>
          )}
        </React.Fragment>
      ),
    },
  ];

  const handleDelete = (contact) => {
    ContactService.remove(contact.id)
      .then((data) => {
        toast.success("Contact supprimé !", { autoClose: 2000 });
        sendUpdate(true);
      })
      .catch((e) => {
        toast.error(e.response.data.description, {
          autoClose: 3000,
          onClose: () => {}, // TODO, mise à jour des écrans
        });
      });
  };

  return (
    <div style={{ height: 450, width: "100%" }}>
      <DataGrid
        localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
        rows={contacts}
        columns={columns}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20]}
        pagination
        checkboxSelection
        rowHeight={40}
        columnHeaderHeight={40}
        components={{ Toolbar: GridToolbar }}
      />
    </div>
  );
};

export default NcAttenteTable;
